const HttpStartStrings = ["h", "ht", "htt", "http"];
const VariableStartStrings = ["{", "{{"];
const MailToStartStrings = ["m", "ma", "mai", "mail", "mailt", "mailto", "mailto:"];

export function withHttp(candidate: string, allowMailto = false) {
  if (!candidate) {
    return candidate;
  }
  if (
    HttpStartStrings.some((str) => candidate.startsWith(str)) ||
    VariableStartStrings.some((str) => candidate.startsWith(str)) ||
    (allowMailto && MailToStartStrings.some((str) => candidate.startsWith(str)))
  ) {
    return candidate;
  }
  return `https://${candidate}`;
}
